'use client';

var classes = {
  "root": "m_8d3f4000",
  "icon": "m_8d3afb97",
  "loader": "m_302b9fb1",
  "group": "m_1a0f1b21"
};
export { classes as default };